import {
  SelectionState,
  SelectionStatus,
} from "@monolith-forensics/monolith-ui";
import { ImportRowValidation } from "../DataImport.types";

/**
 * Resolves the preview Table's inclusion/exclusion selection to the concrete
 * row indexes it stands for. `All` and `SomeExcluded` do not enumerate the
 * selected keys (`selectedRowKeys` is empty after a deselect from "all"), so
 * they are resolved against the full client-side row set.
 */
export const resolveSelectedRowIndexes = (
  selectionState: SelectionState,
  rows: ImportRowValidation[]
): Set<number> => {
  switch (selectionState.selectionStatus) {
    case SelectionStatus.All:
      return new Set(rows.map((r) => r.rowIndex));
    case SelectionStatus.SomeExcluded: {
      const excluded = new Set(selectionState.excludedRowKeys);
      return new Set(
        rows
          .filter((r) => !excluded.has(String(r.rowIndex)))
          .map((r) => r.rowIndex)
      );
    }
    case SelectionStatus.SomeIncluded:
      return new Set(selectionState.selectedRowKeys.map(Number));
    default:
      return new Set();
  }
};
